import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { ActorSendGroupStatusInformationModel } from 'src/app/models/api/actor-status-information.model';
import { Subscription } from 'rxjs';
import { RequestStatusService } from '../../requeststatus.service';
import { SendGroupModel } from 'src/app/models/sendgroup.model';

@Injectable()
export class RequestStatusSendgroupListComponent implements OnDestroy, OnInit{
  requestGuid!: string;
  actors: ActorSendGroupStatusInformationModel[] = [];
  groups: SendGroupModel[] = [];
  sendGroups: ActorSendGroupStatusInformationModel[] = [];
  protected requestSubscription!: Subscription;
  protected actorListSubscription!: Subscription;
  sendgroups!: ActorSendGroupStatusInformationModel[];

  constructor(protected requestStatusService: RequestStatusService) {
    this.requestSubscription = this.requestStatusService.selectedRequest$.subscribe(request => {
      if (Object.keys(request).length === 0) {
        return;
      }
      this.requestGuid = request.id;
    });
  }

  ngOnInit(): void {
    this.actorListSubscription = this.requestStatusService.actors$.subscribe(sendgroups => {
      this.sendGroups = sendgroups;
    });
  }

  ngOnDestroy() {
    // verify and unsubscribe
    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }
    // verify and unsubscribe
    if (this.actorListSubscription) {
      this.actorListSubscription.unsubscribe();
    }
  }

  getSendgroupDeadlines() {
    return this.sendGroups;
  }
}

@Component({
  selector: 'mobile-request-status-sendgroup-list',
  templateUrl: './mobile-request-status-sendgroup-list.component.html'
})
export class MobileRequestStatusSendgroupListComponent extends RequestStatusSendgroupListComponent {
  public override requestGuid!: string;
  public override actors: ActorSendGroupStatusInformationModel[] = [];
  public override groups: SendGroupModel[] = [];
  public override sendGroups: ActorSendGroupStatusInformationModel[] = [];
  protected override requestSubscription!: Subscription;
  protected override actorListSubscription!: Subscription;
  public override sendgroups!: ActorSendGroupStatusInformationModel[];

  constructor(protected override requestStatusService: RequestStatusService) {
    super(requestStatusService);
  }
}


@Component({
  selector: 'desktop-request-status-sendgroup-list',
  templateUrl: './desktop-request-status-sendgroup-list.component.html'
})
export class DesktopRequestStatusSendgroupListComponent extends RequestStatusSendgroupListComponent {
  public override requestGuid!: string;
  public override actors: ActorSendGroupStatusInformationModel[] = [];
  public override groups: SendGroupModel[] = [];
  public override sendGroups: ActorSendGroupStatusInformationModel[] = [];
  protected override requestSubscription!: Subscription;
  protected override actorListSubscription!: Subscription;
  public override sendgroups!: ActorSendGroupStatusInformationModel[];

  constructor(protected override requestStatusService: RequestStatusService) {
    super(requestStatusService);
  }
}
